import type {
  ButtonHTMLAttributes,
  MouseEventHandler,
  ReactNode,
} from "react";
import { Link } from "react-router-dom";

export type ActionButtonVariant =
  | "primary"
  | "secondary"
  | "light";

type SharedProps = {
  children: ReactNode;
  className?: string;
  variant?: ActionButtonVariant;
  fullWidth?: boolean;
};

type ActionLinkProps = SharedProps & {
  to: string;
  type?: never;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

type ActionNativeButtonProps = SharedProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    to?: never;
  };

export type ActionButtonProps =
  | ActionLinkProps
  | ActionNativeButtonProps;

export function ActionButton(props: ActionButtonProps) {
  const {
    children,
    className = "",
    fullWidth = false,
    variant = "primary",
  } = props;

  const classes = [
    "oac-action-button",
    `oac-action-button--${variant}`,
    fullWidth ? "oac-action-button--full-width" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if ("to" in props && props.to) {
    return (
      <Link
        className={classes}
        onClick={props.onClick}
        to={props.to}
      >
        {children}
      </Link>
    );
  }

  const {
    to: _to,
    ...buttonProps
  } = props as ActionNativeButtonProps & {
    to?: never;
  };

  return (
    <button
      {...buttonProps}
      className={classes}
      type={buttonProps.type ?? "button"}
    >
      {children}
    </button>
  );
}
